import { AnyAction } from 'redux';

import { NavigationState, navigationActions } from './navigation.types';

export const navigationInitialState: NavigationState = {
	current: '/',
	flow: 'subscription',
};

export const navigationReducer: (state: NavigationState | undefined, action: AnyAction) => NavigationState = (
	state = navigationInitialState,
	action
): NavigationState => {
	if (action.type === navigationActions.saveStep) {
		return {
			...state,
			...action.payload,
		};
	}
	return state;
};
